import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { login } from '../actions/userActions'
import Loading from '../components/Loading'

const Login = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleLogin = () => {
    if (!email || !password) {
      toast('All the fields are mandatory', { type: 'error', hideProgressBar: true, autoClose: 2000 })
    } else {
      dispatch(login(email.toLowerCase(), password))
    }
  }

  const { loadingUserInfo, errorUserInfo, userInfo } = useSelector(state => state.userLogin)

  useEffect(() => {
    if (userInfo) {
      if (userInfo.role.name === 'Client') navigate('/banktasks')
      else if (userInfo.role.name === 'Collection Supervisor') navigate('/dailyCollection')
      else if (userInfo.role?.name?.toLowerCase() === 'merchant' || userInfo.merchantId) {
        navigate('/merchant/dashboard')
      }
      else navigate('/admin/enquiries')
    } else if (errorUserInfo) {
      toast(errorUserInfo, { type: 'error', hideProgressBar: true, autoClose: 2000 })
    }
  }, [userInfo, errorUserInfo, navigate])

  if (loadingUserInfo) return <Loading />

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <ToastContainer />
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-xl shadow-sm p-8">
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-semibold text-gray-800">Loan Enquiry</h1>
            <p className="text-sm text-gray-500 mt-1">Enter your credentials to sign in</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                disabled={loadingUserInfo}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="••••••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                disabled={loadingUserInfo}
                onKeyDown={e => e.key === 'Enter' && handleLogin()}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50"
              />
            </div>

            <button
              type="button"
              onClick={handleLogin}
              disabled={loadingUserInfo}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white text-sm font-medium py-2.5 rounded-lg transition-colors"
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
